// Click-to-reference (wave-2 S2). Wrap anything the user might point the agent
// at. While the widget is open, ⌥-click (Alt/Option) turns it into a reference
// pill in the composer; the snapshot rides with the next message. Silent and
// inert when the widget is closed, so normal clicks pass straight through.
// ponytail: Alt-click only — no long-press; this is a desktop internal tool.

import type { ReactNode } from "react";
import { useAgent } from "./AgentProvider";
import "./agent.css";

export function Referable({
  label,
  snapshot,
  children,
}: {
  label: string;
  snapshot: Record<string, unknown>;
  children: ReactNode;
}) {
  const { open, addReference } = useAgent();
  return (
    <span
      className={`agent-referable${open ? " agent-referable--armed" : ""}`}
      onClickCapture={(e) => {
        if (!open || !e.altKey) return; // only hijack ⌥-click while the widget is open
        e.preventDefault();
        e.stopPropagation();
        addReference({ label, snapshot });
      }}
      title={open ? "⌥-click to ask the agent about this" : undefined}
    >
      {children}
    </span>
  );
}
